<template>
    <div >
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.news')" />
            </template>
        </PageHeader>
        <Search />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import FreeTrial from '../Common/FreeTrial'
import PageTitle from '../Common/PageTitle'
import Search from '../Search/Search'
import Footer from '../Layout/Footer'

export default {
    name: 'SearchPage',
    components: {
        Navbar,
        PageTitle,
        PageHeader,
        FreeTrial,
        Search,
        Footer,
    }
}
</script>
